import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 2px;\n  box-shadow: none;\n  height: 30px;\n  line-height: 30px;\n  font-size: 13px;\n  margin: 0;\n  min-width: 50px;\n  padding: 7px 10px;\n  text-align: center;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 2px;\n  box-shadow: none;\n  height: 30px;\n  line-height: 30px;\n  font-size: 13px;\n  margin: 0;\n  min-width: 50px;\n  padding: 7px 10px;\n  text-align: center;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  ', '\n\n  ', '\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      background-color: ', ';\n      border-color: ', ';\n      color: ', ';\n    '], ['\n      background-color: ', ';\n      border-color: ', ';\n      color: ', ';\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      border-color: ', ';\n      color: ', ';\n      text-decoration: line-through;\n    '], ['\n      border-color: ', ';\n      color: ', ';\n      text-decoration: line-through;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      background: ', ';\n      color: ', ';\n    '], ['\n      background: ', ';\n      color: ', ';\n    ']);

import styled, { css } from 'styled-components';

export var StyledLabel = styled.label(_templateObject, function (props) {
  return props.theme.dormifyWhite;
}, function (props) {
  return props.theme.dormifyBlack;
}, function (_ref) {
  var active = _ref.active,
      theme = _ref.theme;
  return (
    // active styles
    active && css(_templateObject2, theme.dormifyBlack, theme.dormifyBlack, theme.dormifyWhite)
  );
}, function (_ref2) {
  var optionAvailable = _ref2.optionAvailable,
      theme = _ref2.theme;
  return (
    // unaavailabe styles
    !optionAvailable && css(_templateObject3, theme.dormifyLightGrey, theme.dormifyLightGrey)
  );
}, function (_ref3) {
  var optionAvailable = _ref3.optionAvailable,
      active = _ref3.active,
      theme = _ref3.theme;
  return (
    // unavailable and active styles
    !optionAvailable && active && css(_templateObject4, theme.dormifyLightGrey, theme.dormifyWhite)
  );
});